<template>
  <div class="addApplicationForVehicle">
    <div class="newsDetial-header">
      <template v-if="!id">
        <div class="newsDetial-title">新建表单</div>
        <blank height="15"> </blank>
        <div class="newsDetial-abstract">
          请按照文本要求添加表单，并提交进行流程审批
        </div>
        <!-- <blank height="45"> </blank> -->
      </template>
      <div slot="title" class="card-title">
        <!-- <div class="newsDetial-title mb10">医药费审批流程</div> -->
        <div
          class="newsDetial-title mb10"
          v-if="tabnum == 1 && this.$route.query.index != 1"
        >
          医药费报销详情
        </div>
        <div
          class="newsDetial-title mb10"
          v-if="tabnum == 2 && this.$route.query.index != 1"
        >
          医药费报销审批流程
        </div>
        <div class="state1" v-if="Form.state == 1">审批中</div>
        <div class="state2" v-if="Form.state == 2">已归档</div>
        <div class="state3" v-if="Form.state == 3">退回</div>
        <div class="state4" v-if="Form.state == 4">取消</div>
        <!-- <template v-for="(item, index) in $store.state.app.formStatusList">
          <div
            :class="'state' + baseInfo.state"
            v-if="baseInfo.state == item.value"
            :key="index"
          >
            {{ item.label }}
          </div>
        </template> -->
      </div>
      <a-tabs v-model="tabnum" @change="tabClick">
        <a-tab-pane key="1" tab="表单详情" v-if="id" />
        <!-- 草稿未开启审批流不展示跳转审批流按钮 -->
        <a-tab-pane key="2" tab="表单流程" v-if="Form.state > 0" />
      </a-tabs>
    </div>
    <!-- 页面内容 -->
    <div class="detial-cont">
      <template v-if="tabnum == 1">
        <!-- 基本信息 -->
        <div class="detial-cont-title">
          基本信息
          <!-- {{ baseInfo.departmentName }} -->
          <!-- 类型申请、代客下单:{{ type }} 增改查状态:{{stateIndex}}
          表单不可编辑:{{ disabled }} -->
        </div>
        <blank height="1"> </blank>
        <div class="detial-cont-view">
          <a-descriptions layout="vertical">
            <!-- 第一行 部门  代客下单可编辑 申请不可编辑-->
            <a-descriptions-item>
              <span slot="label"
                >部门/单位
                <span class="required">*</span>
              </span>
              <a-tooltip placement="topLeft" :title="baseInfo.organizationName">
                <div>
                  <a-tree-select
                    :disabled="disabled"
                    v-model="baseInfo.organizationId"
                    :value="baseInfo.organizationName"
                    :label="baseInfo.organizationName"
                    class="w300"
                    :dropdown-style="{ maxHeight: '400px', overflow: 'auto' }"
                    :tree-data="organizationUserList"
                    placeholder="请选择部门"
                    tree-default-expand-all
                    :replaceFields="replaceFields"
                    @change="getUserListFn"
                  >
                  </a-tree-select>
                </div>
              </a-tooltip>
            </a-descriptions-item>
            <!-- 报销职工姓名 代客下单可编辑 申请不可编辑 -->
            <a-descriptions-item>
              <span slot="label"
                >报销职工姓名<span class="required">*</span>
              </span>
              <template v-if="type == 2">
                <!-- v-model="$store.state.app.userInfo.fullName" -->
                <a-input
                  :disabled="disabled"
                  class="w300"
                  placeholder="请添加"
                  v-model="baseInfo.fullName"
                />
              </template>
              <a-input
                v-if="type != 2"
                style="width: 215px"
                placeholder="请选择报销职工"
                v-model="baseInfo.fullName"
                :disabled="true"
              />
              <a-button
                type="primary"
                v-if="type != 2"
                class="ml20"
                :disabled="disabled"
                @click="selectUserFn"
              >
                选择
              </a-button>
              <!-- <a-button v-if="type != 1" class="w300" @click="selectUserFn">
                <span v-if="!baseInfo.fullName"
                  >点击选择人员 {{ baseInfo.fullName }}</span
                >
                <span v-else>{{ baseInfo.fullName }}</span>
              </a-button> -->
              <!-- <a-select
                v-if="type != 1"
                placeholder="请添加"
                class="w300"
                :filter-option="filterOption"
                v-model="baseInfo.fullName"
                :disabled="disabled"
                @change="selecktUser"
              >
                <a-select-option
                  v-for="i in userList"
                  :value="i.fullName"
                  :key="i.id"
                  >{{ i.fullName }}</a-select-option
                >
              </a-select> -->
            </a-descriptions-item>
            <!--申请没有 代课下单有 代办人 -->
            <template v-if="type == 3">
              <a-descriptions-item v-if="id">
                <span slot="label">代办人 <span class="required">*</span></span>
                <a-input
                  class="w300"
                  placeholder="请添加"
                  v-model="detailsfullName"
                  :disabled="true"
                />
              </a-descriptions-item>
              <a-descriptions-item v-if="!id">
                <span slot="label">代办人 <span class="required">*</span></span>
                <a-input
                  class="w300"
                  placeholder="请添加"
                  v-model="$store.state.app.userInfo.fullName"
                  :disabled="true"
                />
              </a-descriptions-item>
            </template>
            <!-- 手机号 -->
            <a-descriptions-item>
              <span slot="label">手机号码<span class="required">*</span> </span>
              <a-input
                class="w300"
                placeholder="请添加"
                v-model="baseInfo.phoneNumber"
                :disabled="true"
              />
            </a-descriptions-item>

            <!-- 第二行  身份证号码-->
            <a-descriptions-item>
              <span slot="label"
                >身份证号码<span class="required">*</span></span
              >
              <a-input
                :disabled="true"
                class="w300"
                placeholder="请添加"
                v-model="baseInfo.idCardNumber"
              />
            </a-descriptions-item>
            <!-- 银行卡号 -->
            <a-descriptions-item>
              <!-- <span slot="label">银行卡号<span class="required">*</span> </span
              > -->
              <span slot="label">银行卡号</span>
              <a-input
                class="w300"
                placeholder="请添加"
                v-model="baseInfo.cardNumber"
                :disabled="true"
              />
            </a-descriptions-item>
            <!-- 报销年度 -->
            <a-descriptions-item>
              <span slot="label">
                报销年度 <span class="required">*</span></span
              >
              <a-select
                allowClear
                placeholder="请选择报销年度"
                class="w300"
                v-model="baseInfo.year"
                :disabled="disabled"
              >
                <!--  yearList -->
                <a-select-option
                  v-for="(item, index) in importYearList"
                  :key="index"
                  :value="item"
                  >{{ item + "年度" }}</a-select-option
                >
              </a-select>
            </a-descriptions-item>

            <!-- 另一些信息 查看和修改时显示 申请和代客下单的时候的新增不显示-->
            <!-- 第一行 门诊自付一金额（元）-->
            <a-descriptions-item v-if="stateIndex != 1 && baseInfo.state != 0">
              <span slot="label">门诊自付一金额（元） </span>
              <a-input
                :disabled="disabled"
                class="w300"
                placeholder=""
                v-model="baseInfo.outpatientSelfPaymentOne"
                @change="countOutTotal"
              />
            </a-descriptions-item>
            <!-- 门诊自付二金额（元） -->
            <a-descriptions-item v-if="stateIndex != 1 && baseInfo.state != 0">
              <span slot="label">门诊自付二金额（元） </span>
              <a-input
                :disabled="disabled"
                class="w300"
                placeholder=""
                v-model="baseInfo.outpatientSelfPaymentTwo"
                @change="countOutTotal"
              />
            </a-descriptions-item>
            <!-- 门诊自费金额（元） -->
            <a-descriptions-item v-if="stateIndex != 1 && baseInfo.state != 0">
              <span slot="label">门诊自费金额（元） </span>
              <a-input
                :disabled="disabled"
                class="w300"
                placeholder=""
                v-model="baseInfo.outpatientSelfExpense"
              />
            </a-descriptions-item>

            <!-- 第二行 -->
            <a-descriptions-item v-if="stateIndex != 1 && baseInfo.state != 0">
              <span slot="label">门诊自付总金额（元） </span>
              <a-input
                :disabled="disabled"
                class="w300"
                placeholder=""
                v-model="baseInfo.outpatientFee"
              />
            </a-descriptions-item>
            <a-descriptions-item v-if="stateIndex != 1 && baseInfo.state != 0">
              <span slot="label">门诊报销核算类型 </span>
              <a-select
                :disabled="disabled"
                allowClear
                placeholder="请选择"
                class="w300"
                v-model="baseInfo.outpatientReimbursementType"
                @change="getRateList(baseInfo.outpatientReimbursementType, 3)"
              >
                <a-select-option
                  v-for="(item, index) in $store.state.bytype
                    .outReimbursementTypeList"
                  :key="index"
                  :value="item.id"
                  >{{ item.reimbursementGroup }}</a-select-option
                >
              </a-select>
            </a-descriptions-item>
            <a-descriptions-item v-if="stateIndex != 1 && baseInfo.state != 0">
              <!--  {{ outReimOnlineFee }} -->
              <span slot="label">门诊实际报销金额</span>
              <a-input
                :disabled="disabled"
                class="w300"
                placeholder=""
                v-model="baseInfo.outpatientFinalFee"
              />
            </a-descriptions-item>

            <!-- 第三行  -->
            <!-- 住院自付一金额-->
            <a-descriptions-item v-if="stateIndex != 1 && baseInfo.state != 0">
              <span slot="label">住院自付一金额（元） </span>
              <a-input
                :disabled="disabled"
                class="w300"
                placeholder=""
                v-model="baseInfo.hospitalizationSelfPaymentOne"
                @change="countHospitalTotal"
              />
            </a-descriptions-item>
            <!-- 住院自付二金额 -->
            <a-descriptions-item v-if="stateIndex != 1 && baseInfo.state != 0">
              <span slot="label">住院自付二金额（元） </span>
              <a-input
                :disabled="disabled"
                class="w300"
                placeholder=""
                v-model="baseInfo.hospitalizationSelfPaymentTwo"
                @change="countHospitalTotal"
              />
            </a-descriptions-item>
            <!-- 住院自费金额（元） -->
            <a-descriptions-item v-if="stateIndex != 1 && baseInfo.state != 0">
              <span slot="label">住院自费金额（元） </span>
              <a-input
                :disabled="disabled"
                class="w300"
                placeholder=""
                v-model="baseInfo.hospitalizationSelfExpense"
              />
            </a-descriptions-item>

            <!-- 第四行 -->
            <a-descriptions-item v-if="stateIndex != 1 && baseInfo.state != 0">
              <span slot="label">住院自付总金额（元） </span>
              <a-input
                :disabled="disabled"
                class="w300"
                placeholder=""
                v-model="baseInfo.hospitalizationFee"
              />
            </a-descriptions-item>

            <a-descriptions-item v-if="stateIndex != 1 && baseInfo.state != 0">
              <span slot="label">住院报销核算类型 </span>
              <a-select
                :disabled="disabled"
                allowClear
                placeholder="请选择"
                class="w300"
                v-model="baseInfo.hospitalizationType"
                @change="getRateList(baseInfo.hospitalizationType, 2)"
              >
                <a-select-option
                  v-for="(item, index) in $store.state.bytype
                    .hosptReimbursementTypeList"
                  :key="index"
                  :value="item.id"
                  >{{ item.reimbursementGroup }}</a-select-option
                >
              </a-select>
            </a-descriptions-item>

            <a-descriptions-item v-if="stateIndex != 1 && baseInfo.state != 0">
              <!--  {{ hospitalOnlineFee }} -->
              <span slot="label">住院实际报销金额（元）</span>
              <a-input
                :disabled="disabled"
                class="w300"
                placeholder=""
                v-model="baseInfo.hospitalizationFinalFee"
              />
            </a-descriptions-item>

            <!-- 第五行 实际报销总金额（元） -->
            <a-descriptions-item v-if="stateIndex != 1 && baseInfo.state != 0">
              <span slot="label">实际报销总金额（元） </span>
              <a-input
                :disabled="disabled"
                class="w300"
                placeholder=""
                v-model="baseInfo.totalFee"
              />
            </a-descriptions-item>
            <a-descriptions-item v-if="stateIndex != 1 && baseInfo.state != 0">
              <span slot="label">备注 </span>
              <a-textarea
                :disabled="disabled"
                class="w300"
                placeholder=""
                v-model="baseInfo.remark"
                auto-size
              />
            </a-descriptions-item>
          </a-descriptions>
        </div>
        <!-- 批次表格 -->
        <a-card>
          <!-- <div slot="title" class="card-title"> -->
          <!-- <span class="mr10"
              >{{ baseInfo.year }}第{{
                baseInfo.batch ? baseInfo.batch : 1
              }}批次</span
            > -->
          <!-- <template v-for="(item, index) in $store.state.app.formStatusList">
              <div
                :class="'state' + baseInfo.state"
                v-if="baseInfo.state == item.value"
                :key="index"
              >
                {{ item.label }}
              </div>
            </template> -->
          <!-- </div> -->
          <a-card title="底方附件">
            <!-- 底方附件 -->
            <voucher-table
              v-model="recipeList"
              :file="recipeList"
              :disabled="disabled"
              :id="id"
            ></voucher-table>
          </a-card>
          <a-card :style="{ marginTop: '16px' }">
            <div slot="title" class="card-item-title">
              <span>门诊发票附件</span>
              <!-- <span
                >自付总额（元）：<span class="orange"
                  >￥{{ outpatientDepPay }}</span
                >
              </span> -->
              <!-- <a-button type="link" v-if="id" @click="lookList(1)">
                查看更多
              </a-button> -->
            </div>
            <!-- 发票附件 -->
            <invoice-table
              v-model="outpatientDepList"
              :file="outpatientDepList"
              :disabled="disabled"
              :id="id"
            ></invoice-table>
          </a-card>
          <a-card :style="{ marginTop: '16px' }">
            <div slot="title" class="card-item-title">
              <span>住院发票附件</span>
              <!-- <span
                >自付总额（元）：<span class="orange">￥{{ hospitalPay }}</span>
              </span> -->
              <!-- <a-button type="link" v-if="id" @click="lookList(2)">
                查看更多
              </a-button> -->
            </div>
            <!-- 发票附件 -->
            <invoice-table
              v-model="hospitalList"
              :file="hospitalList"
              :disabled="disabled"
              :id="id"
            ></invoice-table>
          </a-card>
        </a-card>
        <model-list
          ref="modelList"
          :type="invoiceType"
          :id="id"
          :disabled="disabled"
          @updateDetails="medicalReimbursementBatchGetFn"
        ></model-list>
      </template>
      <div class="detial-cont" v-if="tabnum == 2">
        <div class="detial-cont-title">审批流程图示</div>
        <blank height="1"> </blank>
        <div class="detial-cont-view">
          <!-- 审批流 表单流程 -->
          <keep-alive>
            <approvalChart
              ref="refChart"
              :approvalChartData="approvalChartData"
            ></approvalChart>
          </keep-alive>
        </div>
      </div>

      <template v-if="tabnum == 1">
        <bottomSuspension>
          <a-button :style="{ marginRight: '20px' }" @click="goback">
            返回
          </a-button>
          <!-- 表单为可编辑状态 显示提交按钮 -->
          <template>
            <div v-if="proQueryParams.isEdit === '0' ? true : false">
              <a-button
                :loading="confirmLoading && Form.draft == 2"
                type="primary"
                class="orange-btn"
                @click="preserveFn('0')"
                :style="{ marginRight: '20px' }"
              >
                保存
              </a-button>
            </div>
            <a-button
              v-if="!Form.state && !disabled"
              :loading="confirmLoading && Form.draft == 1"
              type="primary"
              class="orange-btn"
              @click="preserveFn('1')"
              :style="{ marginRight: '20px' }"
            >
              保存
            </a-button>
            <a-button
              v-if="!Form.state && !disabled"
              :loading="loading && Form.draft == 2"
              type="primary"
              :style="{ marginRight: '20px' }"
              @click="submitFn"
            >
              提交
            </a-button>
            <a-button
              v-if="proQueryParams.showApproveBtn === '1'"
              :loading="loading && Form.draft == 2"
              type="primary"
              :style="{ marginRight: '20px' }"
              @click="submitFn"
            >
              {{ Form.state === 3 ? "提交" : "审批" }}
            </a-button>
          </template>
          <!-- 表单正在审批状态  显示审批按钮 -->
          <div v-if="proQueryParams.showApproveBtn === '1' ? true : false">
            <a-button
              v-if="Form.state === 3 ? true : false"
              type="danger"
              @click="cancelPro('2')"
              :style="{ marginRight: '20px' }"
            >
              删除
            </a-button>
            <!-- <a-button
            v-if="Form.state === 3 ? true : false"
            type="primary"
            @click="cancelPro('1')"
            :style="{ marginRight: '20px' }"
          >
            提交
          </a-button>
          <a-button
            v-if="Form.state === 3 ? false : true"
            @click="approvalPro"
            type="primary"
            :style="{ marginRight: '42px' }"
          >
            审批
          </a-button> -->
          </div>
        </bottomSuspension>
      </template>
      <!-- 审批流审批弹窗 -->
      <approvalSubmission v-model="isActivitiMode"></approvalSubmission>
    </div>

    <!-- 提示选择的人没有对应的信息 -->
    <a-modal
      :visible="visiblePerson"
      :width="400"
      title="提示"
      @ok="handleOk"
      @cancel="handleCancel"
    >
      <p>该员工没有身份证或银行卡信息</p>
      <p>请联系管理员进行信息导入</p>
    </a-modal>

    <!-- 选择人员弹窗 -->
    <a-modal
      :visible="visibleSelectUser"
      :width="600"
      title="请选择报销人员"
      @ok="handleOkSelectUser"
      @cancel="handleCancelSelectUser"
    >
      <a-input
        allowClear
        class="w300 mr20"
        placeholder="请输入报销人员"
        v-model="searchFullName"
      />
      <a-button type="primary" @click="collectionMit"> 查询</a-button>
      <blank height="20"> </blank>
      <a-table
        :pagination="false"
        :columns="columnsUser"
        :data-source="userList"
        :row-key="record => record.id"
        :row-selection="{
          onChange: onChange
        }"
      >
        <span slot="index" slot-scope="text, record, index">
          {{ index + 1 + (page - 1) * 10 }}
        </span>
      </a-table>
      <div
        style="
          margin-top: 20px;
          display: flex;
          justify-content: flex-end;
          align-items: center;
        "
      >
        <a-pagination
          v-model="userPage"
          :defaultCurrent="userPage"
          :defaultPageSize="userSize"
          :total="userTotal"
          @change="userPageChange"
        />
      </div>
    </a-modal>
  </div>
</template>

<script>
const columnsUser = [
  {
    title: "姓名",
    dataIndex: "fullName",
    key: "fullName",
    width: 100,
    align: "center"
  },
  {
    title: "手机号",
    dataIndex: "phoneNumber",
    key: "phoneNumber",
    width: 100,
    align: "center"
  }
];
import { mapState, mapActions } from "vuex";
import approvalSubmission from "@/components/approval-submission/index";
import approvalChart from "@/components/approval-chart/index";
import { activitiSubmission } from "@/utils/utils";
import { validateIdCard } from "@/assets/js/auth";
import InvoiceTable from "@/components/invoice-table/index.vue";
import VoucherTable from "@/components/voucher-table/index.vue";
import modelList from "./components/model-list.vue";
import { queryLoginUser } from "@/http/url";
import {
  getYear,
  medicalReimbursementBatchGet,
  medicalReimbursementSave,
  getOrganizationList,
  getUserList,
  expenseReimbursementUpdate
} from "./api/api";
import { resolve } from "q";
export default {
  components: {
    approvalSubmission,
    approvalChart,
    InvoiceTable,
    VoucherTable,
    modelList
  },

  data() {
    return {
      // 审批流部分
      // disabled: true,
      isActivitiMode: {
        isActivitiShow: false,
        proQueryParams: []
      },
      proQueryParams: [],
      pIsedit: "",
      Form: {},
      tabnum: "1", // 1表单页面， 2审批流页面
      confirmLoading: false,
      loading: false,
      id: "",
      // 审批流部分
      replaceFields: {
        key: "id",
        value: "id",
        children: "treeList",
        title: "organizationName"
      },
      type: 2, // 表单类型 1自己 2代客 3在职 pc端需要 2代表代客 3申请
      stateIndex: 0, // 1 新增 2 修改 3 查看
      yearList: [],
      importYearList: [2024, 2023, 2022, 2021, 2020],
      userList: [],
      organizationUserList: [],
      baseInfo: {}, // 基本信息
      recipeList: [], // 底方附件
      outpatientDepList: [], // 门诊发票附件
      hospitalList: [], // 住院发票附件
      preserveLoading: false,
      submitLoading: false,
      invoiceCount: 0, // 发票数
      outpatientDepPay: 0, // 门诊自付费用总额
      hospitalPay: 0, // 住院自付费用总额
      invoiceType: null, //发票类型 1-门诊  2-住院
      skipPageReqFlag: "/MedicalFeeDetail",
      outReimStartFee: 0, // 门诊起付线
      hospitalStartFee: 0, // 住院起付线
      visiblePerson: false,
      visibleSelectUser: false,
      columnsUser, // 人员弹窗列
      userPage: 1,
      userSize: 5,
      userTotal: 0,
      userIds: [],
      searchFullName: "",
      detailsfullName: null,
      outReimOnlineFee: null,
      outReimStartFee: null
    };
  },
  computed: {
    ...mapState(["app"]),
    // 获取表单是否可编辑状态  false可编辑  true不可编辑
    disabled: function() {
      //  新增和修改可编辑
      if (this.stateIndex == 1 || this.stateIndex == 2) {
        return false;
      } else if (this.stateIndex == 3) {
        // 查看 不可以编辑
        return true;
      } else if (this.type == 1) {
        // return true
      } else {
        this.proQueryParams = this.$route.query;
        if (this.proQueryParams.isEdit) {
          if (
            this.proQueryParams.isEdit === "100" ||
            this.proQueryParams.isEdit === "1"
          ) {
            return true;
          } else {
            return false;
          }
        } else if (this.Form.state == 1 || this.Form.state == 2) {
          //审批状态和归档状态  不可编辑
          return true;
        } else {
          // 草稿箱或退回状态  可编辑
          return false;
        }
      }
    }
  },
  watch: {
    // 门诊发票附件
    outpatientDepList: {
      handler(val) {
        this.getInvoiceCount();
        this.outpatientDepPay = 0;
        if (!this.isEmpty(val)) {
          val.forEach(item => {
            if (!this.isEmpty(item["fee"])) {
              this.outpatientDepPay += Number(item["fee"]);
            }
          });
        }
      },
      deep: true
    },
    // 住院发票附件
    hospitalList: {
      handler(val) {
        this.getInvoiceCount();
        this.hospitalPay = 0;
        if (!this.isEmpty(val)) {
          val.forEach(item => {
            if (!this.isEmpty(item["fee"])) {
              this.hospitalPay += Number(item["fee"]);
            }
          });
        }
      },
      deep: true
    }
  },
  created() {
    this.queryLoginUserFn();
    // 获取路由的id 修改和查看需要这个参数
    this.id = this.$route.query.id ? this.$route.query.id : "";
    // 申请、代客下单
    if (this.$route.query.type) {
      this.type = this.$route.query.type;
    }
    // 获取当前列表的状态 是新增 修改还是查看
    this.stateIndex = this.$route.query.index ? this.$route.query.index : "";
    this.getOrganizationListFn(); // 获取部门单位
    this.getYearFn(); // 获取年度下拉
    // 如果路由有id 则进行查询修改回显
    if (this.$route.query.id) {
      this.id = this.$route.query.id;
      // 查询详情 或修改 回显
      this.medicalReimbursementBatchGetFn();
    } else {
      // 获取报销类型下拉列表
      this.$store.dispatch("getReimbursementTypeFn", {
        type: 2,
        workersType: this.type
      });
      this.$store.dispatch("getReimbursementTypeFn", {
        type: 3,
        workersType: this.type
      });
    }
    if (this.type == 2) {
      this.baseInfo.phoneNumber = this.$store.state.app.userInfo.phoneNumber;
    }
    // 如果是申请则是带过来的数据
    if (this.type == 2) {
      this.baseInfo.organizationId = this.$store.state.app.userInfo.organizationId;
      this.baseInfo.fullName = this.$store.state.app.userInfo.fullName;
      this.baseInfo.userId = this.$store.state.app.userInfo.id;
      this.baseInfo.idCardNumber = this.$store.state.app.userInfo.idCardNumber;
      this.baseInfo.cardNumber = this.$store.state.app.userInfo.bankCardNumber;
      if (this.$route.query.fromHomePage != 0) {
        if (
          !this.$store.state.app.userInfo.bankCardNumber ||
          this.$store.state.app.userInfo.bankCardNumber == null ||
          !this.$store.state.app.userInfo.idCardNumber ||
          this.$store.state.app.userInfo.bankCardNumber == null
        ) {
          // this.visiblePerson = true;
        }
      }

      this.baseInfo.departmentName = this.$store.state.app.userInfo.organizationNamePath
        .split("-")
        .pop();
    }
  },
  methods: {
    // 获取用户信息
    queryLoginUserFn() {
      queryLoginUser().then(res => {
        if (res.data.code == 0) {
          this.$store.commit("set_userInfo", res.data.data);
        }
      });
    },

    // 计算门诊自付总金额
    countOutTotal() {
      let outpatientSelfPaymentOne = 0,
        outpatientSelfPaymentTwo = 0;
      if (this.baseInfo.outpatientSelfPaymentOne) {
        outpatientSelfPaymentOne = Number(
          this.baseInfo.outpatientSelfPaymentOne
        );
      }
      if (this.baseInfo.outpatientSelfPaymentTwo) {
        outpatientSelfPaymentTwo = Number(
          this.baseInfo.outpatientSelfPaymentTwo
        );
      }
      this.baseInfo.outpatientFee =
        Number(outpatientSelfPaymentOne) + Number(outpatientSelfPaymentTwo);
      this.countFinalFee(3);
    },
    // 计算住院自付总金额
    countHospitalTotal() {
      let hospitalizationSelfPaymentOne = 0,
        hospitalizationSelfPaymentTwo = 0;
      if (this.baseInfo.hospitalizationSelfPaymentOne) {
        hospitalizationSelfPaymentOne = Number(
          this.baseInfo.hospitalizationSelfPaymentOne
        );
      }
      if (this.baseInfo.hospitalizationSelfPaymentTwo) {
        hospitalizationSelfPaymentTwo = Number(
          this.baseInfo.hospitalizationSelfPaymentTwo
        );
      }
      this.baseInfo.hospitalizationFee =
        Number(hospitalizationSelfPaymentOne) +
        Number(hospitalizationSelfPaymentTwo);
      this.countFinalFee(2);
    },
    // 计算实际报销金额
    countFinalFee(type) {
      // type == 2 医院     3门诊
      if (type == 2) {
        let hospitalizationSelfPaymentOne = 0,
          hospitalizationSelfPaymentTwo = 0;
        if (this.baseInfo.hospitalizationSelfPaymentOne) {
          hospitalizationSelfPaymentOne = this.baseInfo
            .hospitalizationSelfPaymentOne;
        }
        if (this.baseInfo.hospitalizationSelfPaymentTwo) {
          hospitalizationSelfPaymentTwo = this.baseInfo
            .hospitalizationSelfPaymentTwo;
        }
        this.baseInfo.hospitalizationFinalFee = (
          (Number(hospitalizationSelfPaymentOne) +
            Number(hospitalizationSelfPaymentTwo) -
            Number(this.hospitalStartFee)) *
          (Number(this.baseInfo.hospitalizationProportion) * 0.01)
        ).toFixed(2);
        console.log(this.baseInfo);
        if (this.baseInfo.hospitalizationFinalFee < 0) {
          this.baseInfo.hospitalizationFinalFee = 0;
          // this.$message.warning('您未达到报销金额，此金额不参与报销')
        } else if (
          this.baseInfo.hospitalizationFinalFee > Number(this.hospitalOnlineFee)
        ) {
          this.baseInfo.hospitalizationFinalFee = Number(
            this.hospitalOnlineFee
          );
        }
      } else if (type == 3) {
        let outpatientSelfPaymentOne = 0,
          outpatientSelfPaymentTwo = 0;
        if (this.baseInfo.outpatientSelfPaymentOne) {
          outpatientSelfPaymentOne = this.baseInfo.outpatientSelfPaymentOne;
        }
        if (this.baseInfo.outpatientSelfPaymentTwo) {
          outpatientSelfPaymentTwo = this.baseInfo.outpatientSelfPaymentTwo;
        }
        this.baseInfo.outpatientFinalFee = (
          (Number(outpatientSelfPaymentOne) +
            Number(outpatientSelfPaymentTwo) -
            Number(this.outReimStartFee)) *
          (Number(this.baseInfo.outpatientProportion) * 0.01)
        ).toFixed(2);

        if (this.baseInfo.outpatientFinalFee < 0) {
          this.baseInfo.outpatientFinalFee = 0;
          // this.$message.warning('您未达到报销金额，此金额不参与报销')
        } else if (
          this.baseInfo.outpatientFinalFee > Number(this.outReimOnlineFee)
        ) {
          this.baseInfo.outpatientFinalFee = Number(this.outReimOnlineFee);
        }
      }
      let hospitalizationFinalFee = 0,
        outpatientFinalFee = 0;
      if (this.baseInfo.hospitalizationFinalFee) {
        hospitalizationFinalFee = this.baseInfo.hospitalizationFinalFee;
      }
      if (this.baseInfo.outpatientFinalFee) {
        outpatientFinalFee = this.baseInfo.outpatientFinalFee;
      }
      this.baseInfo.totalFee =
        Number(hospitalizationFinalFee) + Number(outpatientFinalFee);
    },
    // 选择报销类型
    getRateList(reimbursementGroup, type) {
      this.$store.dispatch("getReimbursementTypeFn", {
        type: type,
        workersType: this.type,
        id: reimbursementGroup
      });
      if (type == 2) {
        // 医院
        if (!this.isEmpty(reimbursementGroup)) {
          let arr = this.$store.state.bytype.hosptReimbursementTypeList.filter(
            item => {
              return reimbursementGroup == item.id;
            }
          )[0];
          this.hospitalOnlineFee = arr["onlineFee"];
          this.hospitalStartFee = arr["startFee"];
          this.baseInfo.hospitalizationProportion = arr["proportion"];
        } else {
          this.hospitalOnlineFee = 0;
          this.hospitalStartFee = 0;
          this.baseInfo.hospitalizationProportion = "";
        }
      } else if (type == 3) {
        if (!this.isEmpty(reimbursementGroup)) {
          let arr = this.$store.state.bytype.outReimbursementTypeList.filter(
            item => {
              return reimbursementGroup == item.id;
            }
          )[0];
          this.outReimOnlineFee = arr["onlineFee"];
          this.outReimStartFee = arr["startFee"];
          this.baseInfo.outpatientProportion = arr["proportion"];
        } else {
          this.outReimOnlineFee = 0;
          this.outReimStartFee = 0;
          this.baseInfo.outpatientProportion = "";
        }
      }
      this.countFinalFee(type);
    },
    // 审批流取消
    cancelPro(key) {
      switch (key) {
        case "1":
          // 提交
          this.$confirm({
            title: "您是否提交?",
            onOk: () => {
              activitiSubmission(this.proQueryParams, "1", this);
            },
            onCancel: () => {
              console.log("Cancel");
            }
          });
          break;
        case "2":
          // 取消
          this.$confirm({
            title: "您是否删除?",
            onOk: () => {
              activitiSubmission(this.proQueryParams, "2", this);
            },
            onCancel: () => {
              console.log("Cancel");
            }
          });
          break;

        default:
          break;
      }
    },
    // 切换审批流 表单流程
    tabClick(key) {
      if (key == 2) {
        this.approvalChartData = this.proQueryParams;
      } else {
        this.medicalReimbursementBatchGetFn();
      }
    },
    // 固定资产 申请模块 工作流审批
    approvalPro() {
      this.isActivitiMode = {
        isActivitiShow: true,
        proQueryParams: this.proQueryParams
      };
    },
    // 多选搜索按名字搜
    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text
          .toLowerCase()
          .indexOf(input.toLowerCase()) >= 0
      );
    },
    // 计算发票数量
    getInvoiceCount() {
      let outpatientDepLen = 0;
      let hospitalLen = 0;

      if (!this.isEmpty(this.outpatientDepList)) {
        outpatientDepLen = this.outpatientDepList.length;
      }
      if (!this.isEmpty(this.hospitalList)) {
        hospitalLen = this.hospitalList.length;
      }
      this.invoiceCount = Number(outpatientDepLen) + Number(hospitalLen);
    },
    // 提交
    handleSubmit() {
      if (this.id) {
        this.confirmEdit();
      } else {
        this.confimrSave();
      }
    },
    // 保存
    preserveFn(type) {
      if (type === "0") {
        // 自定义保存判断 1 = 仅保存
        this.pIsedit = "1";
        this.Form.draft = 2;
      } else {
        this.pIsedit = "2";
        this.Form.draft = 1;
      }
      if (this.id) {
        this.confirmEdit();
      } else {
        this.confimrSave("保存");
      }
      // this.confimrSave('保存')
    },
    // 提交
    submitFn() {
      if (this.Form.state > 0) {
        this.Form.draft = 2;
        // this.confirmEdit('保存修改')
        this.confirmEdit();
      } else {
        this.$confirm({
          title: "确定提交吗?",
          okType: "danger",
          onOk: () => {
            this.Form.draft = 2;
            if (this.id) {
              this.confirmEdit();
            } else {
              this.confimrSave("保存");
            }
            // this.confimrSave('提交')
          }
        });
      }
    },
    // 新增api
    confimrSave(type) {
      if (this.isEmpty(this.baseInfo.organizationId)) {
        this.$message.error("请输入部门/单位");
        return false;
      }
      if (this.type != 1 && this.isEmpty(this.baseInfo.fullName)) {
        this.$message.error("请输入报销职工名称");
        return false;
      }
      if (this.isEmpty(this.baseInfo.idCardNumber)) {
        this.$message.error("请输入身份证号码");
        return false;
      }
      if (!validateIdCard(this.baseInfo.idCardNumber)) {
        this.$message.error("请输入正确格式的身份证号码");
        return false;
      }

      // if (this.isEmpty(this.baseInfo.cardNumber)) {
      //   this.$message.error("请联系管理员维护银行卡号");
      //   return false;
      // }

      const params = {
        // batchReq: {
        appId: this.$route.meta.appId,
        draft: this.Form.draft, // 草稿箱
        medicalReimbursementAttachment2: this.outpatientDepList, // 门诊发票
        medicalReimbursementAttachment1: this.hospitalList, // 住院发票附件
        medicalReimbursementFile: this.recipeList, //底方附件
        skipPageReqFlag: this.skipPageReqFlag, // 路径
        type: this.type, // 申请 还是代客下单
        // enableNum: this.invoiceCount, // 发票数量 但是不需要
        // },
        cardNumber: this.baseInfo.cardNumber, // 身份证号
        departmentName: this.baseInfo.departmentName, // 部门名称
        organizationId: this.baseInfo.organizationId, // 部门id
        fullName: this.baseInfo.fullName, // 报销职工姓名
        idCardNumber: this.baseInfo.idCardNumber, // 银行卡
        phoneNumber: this.baseInfo.phoneNumber, // 手机号
        year: this.baseInfo.year, // 报销年度
        userId: this.baseInfo.userId // 用户id
      };
      // return
      this.confirmLoading = true;
      medicalReimbursementSave(params).then(res => {
        if (res.data.code == 0) {
          this.$message.success(type + "成功");
          if (this.Form.draft == 2) {
            this.goback();
          } else {
            //首次添加
            this.id = res.data.data;
            this.medicalReimbursementBatchGetFn();
            this.goback();
          }
          this.loading = false;
          this.confirmLoading = false;
        } else {
          this.loading = false;
          this.confirmLoading = false;
        }
      });
    },
    // 修改api
    confirmEdit() {
      const params = {
        appId: this.$route.meta.appId,
        draft: this.Form.draft, // 草稿箱
        medicalReimbursementAttachment2: this.outpatientDepList, // 门诊发票
        medicalReimbursementAttachment1: this.hospitalList, // 住院发票附件
        medicalReimbursementFile: this.recipeList, //底方附件
        skipPageReqFlag: this.skipPageReqFlag, // 路径
        type: this.type, // 申请 还是代客下单
        cardNumber: this.baseInfo.cardNumber, // 身份证号
        departmentName: this.baseInfo.departmentName, // 部门名称
        // departmentName: '测试部门111', // 部门名称 暂时写死
        organizationId: this.baseInfo.organizationId, // 部门id
        fullName: this.baseInfo.fullName, // 报销职工姓名
        idCardNumber: this.baseInfo.idCardNumber, // 银行卡
        phoneNumber: this.baseInfo.phoneNumber, // 手机号
        year: this.baseInfo.year, // 报销年度
        userId: this.baseInfo.userId, // 用户id
        id: this.id,

        // 查看 修改 显示的字段
        outpatientSelfPaymentOne: this.baseInfo.outpatientSelfPaymentOne, // 门诊自付一金额（元）
        outpatientSelfPaymentTwo: this.baseInfo.outpatientSelfPaymentTwo, // 门诊自付二金额（元）
        outpatientSelfExpense: this.baseInfo.outpatientSelfExpense, // 门诊自费金额（元）
        outpatientFee: this.baseInfo.outpatientFee, // 门诊自付总金额（元）
        outpatientReimbursementType:
          this.baseInfo.outpatientReimbursementType.length == 0
            ? null
            : this.baseInfo.outpatientReimbursementType, // 门诊报销核算类型
        outpatientFinalFee: this.baseInfo.outpatientFinalFee, // 门诊实际报销金额
        hospitalizatioSelfPaymentOne: this.baseInfo
          .hospitalizatioSelfPaymentOne, // 住院自付一金额（元）
        hospitalizatioSelfPaymentTwo: this.baseInfo
          .hospitalizatioSelfPaymentTwo, // 住院自付二金额（元）
        hospitalizatioSelfExpense: this.baseInfo.hospitalizatioSelfExpense, // 住院自费金额（元）
        hospitalizationFee: this.baseInfo.hospitalizationFee, // 住院自付总金额（元）
        hospitalizationType:
          this.baseInfo.hospitalizationType.length == 0
            ? null
            : this.baseInfo.hospitalizationType, // 住院报销核算类型
        hospitalizationFinalFee: this.baseInfo.hospitalizationFinalFee, // 住院实际报销金额（元）
        totalFee: this.baseInfo.totalFee, // 实际报销总金额（元）
        remark: this.baseInfo.remark // 备注
      };
      expenseReimbursementUpdate(params).then(res => {
        if (res.data.code == 0) {
          if (this.pIsedit === "1") {
            this.$message.success("操作成功");
            this.pIsedit = "";
          } else {
            if (this.Form.state > 0) {
              this.medicalReimbursementBatchGetFn();
              // 合并 保存+审批流操作
              if (
                this.proQueryParams.showApproveBtn === "1" &&
                this.Form.state != "3"
              ) {
                this.approvalPro();
              } else {
                this.cancelPro("1");
              }
              // this.$message.success('修改成功')
              // 合并 保存+审批流操作
            } else {
              if (this.Form.draft == 2) {
                this.goback();
              }
              this.$message.success("操作成功");
            }
          }
          this.loading = false;
          this.confirmLoading = false;
        } else {
          this.loading = false;
          this.confirmLoading = false;
        }
      });
    },
    // 获取报销详情
    medicalReimbursementBatchGetFn() {
      return new Promise((resolve, reject) => {
        medicalReimbursementBatchGet(this.id).then(res => {
          if (res.data.code == 0) {
            this.Form = res.data.data;
            this.baseInfo = res.data.data;
            this.recipeList = res.data.data.medicalReimbursementFile;
            this.outpatientDepList =
              res.data.data.medicalReimbursementAttachment2;
            this.hospitalList = res.data.data.medicalReimbursementAttachment1;
            this.baseInfo.outpatientReimbursementType =
              this.baseInfo.outpatientReimbursementType === null
                ? []
                : this.baseInfo.outpatientReimbursementType;

            this.baseInfo.hospitalizationType =
              this.baseInfo.hospitalizationType === null
                ? []
                : this.baseInfo.hospitalizationType;
            this.detailsfullName = this.baseInfo.createUserName;
            // 多个对象合并合并多个
            let processInstanceId = {
              processInstanceId: res.data.data.processInstanceId,
              detailsData: res.data.data
            };
            Object.assign(this.proQueryParams, processInstanceId);
            this.type = res.data.data.type;

            this.$store.dispatch("getReimbursementTypeFn", {
              type: 2,
              workersType: res.data.data.type
            });
            this.$store.dispatch("getReimbursementTypeFn", {
              type: 3,
              workersType: res.data.data.type
            });
          }
        });
      });
    },
    // 返回
    goback() {
      this.$router.go(-1);
    },
    //  查看更多
    lookList(type) {
      this.invoiceType = type;
      this.$refs.modelList.setVisible();
    },
    // 查询报销员工
    getUserListFn(organizationId, b, c) {
      this.baseInfo.organizationId = organizationId;
      // 赋值部门名称
      if (b) {
        this.baseInfo.departmentName = b[0] || "";
      }
    },
    // 选择了报销员工
    selecktUser(e) {
      if (!this.isEmpty(e)) {
        let userInfo = this.userList.filter(item => {
          return e == item.fullName;
        })[0];
        this.baseInfo.userId = userInfo["id"];
        this.baseInfo.phoneNumber = userInfo["phoneNumber"];
        this.baseInfo.idCardNumber = userInfo["idCardNumber"];
        this.baseInfo.cardNumber = userInfo["bankCardNumber"];
      } else {
        this.baseInfo.phoneNumber = "";
        this.baseInfo.fullName = "";
        this.baseInfo.idCardNumber = "";
        this.baseInfo.cardNumber = "";
      }
    },
    // 年度下拉
    getYearFn() {
      getYear().then(res => {
        if (res.data.code == 0) {
          this.yearList = res.data.data;
        }
      });
    },
    // 部门单位列表
    getOrganizationListFn() {
      getOrganizationList().then(res => {
        if (res.data.code == 0) {
          this.organizationUserList = res.data.data;
        }
      });
    },
    // ...mapActions(['getcarApplicationTypeList', 'getorganizationUserList']),
    // 输入框限制85
    eightyfive(v, maxNum) {
      if (this.baseInfo[v].length > maxNum) {
        this.baseInfo[v] = this.FobaseInform[v].substring(0, maxNum);
        this.$message.destroy();
        this.$message.warning("只能输入" + maxNum + "个字");
      }
    },
    // 提示窗
    handleOk() {
      this.visiblePerson = false;
    },
    handleCancel() {
      this.visiblePerson = false;
    },
    selectUserFn() {
      if (
        !this.baseInfo.organizationId &&
        this.baseInfo.organizationId == null
      ) {
        this.$message.error("请先选择部门，再选择人员");
        return;
      }
      const params = {
        // dutiesVal: 'duties_type',
        fullName: this.searchFullName || "",
        organizationId: this.baseInfo.organizationId,
        // page: 1,
        // size: 999999
        page: this.userPage,
        size: this.userSize
      };
      getUserList(params).then(res => {
        if (res.data.code == 0) {
          this.searchFullName = "";
          this.userList = res.data.data;
          this.userTotal = res.data.count;
        }
      });
      this.visibleSelectUser = true;
    },
    // 选中之后点击确定
    handleOkSelectUser() {
      if (this.userIds.length > 1) {
        this.$message.error("只允许选择一个人");
        return;
      }
      if (this.userIds) {
        let userInfo = this.userList.filter(item => {
          return this.userIds == item.id;
        })[0];
        this.baseInfo.userId = userInfo["id"];
        this.baseInfo.phoneNumber = userInfo["phoneNumber"];
        this.baseInfo.fullName = userInfo["fullName"];
        this.baseInfo.idCardNumber = userInfo["idCardNumber"];
        this.baseInfo.cardNumber = userInfo["bankCardNumber"];
        this.visibleSelectUser = false;
        // if (!userInfo.bankCardNumber || userInfo.bankCardNumber == null) {
        //   this.visiblePerson = true;
        // }
      } else {
        this.baseInfo.phoneNumber = "";
        this.baseInfo.fullName = "";
        this.baseInfo.idCardNumber = "";
        this.baseInfo.cardNumber = "";
      }
    },
    // 取消
    handleCancelSelectUser() {
      this.visibleSelectUser = false;
      this.userPage = 1;
      this.searchFullName = "";
    },
    // 只需监测发生变化 即可
    onChange(selectedRowKeys, selectedRows) {
      console.log(selectedRowKeys, selectedRows);

      // this.userRowKeys = selectedRowKeys
      this.userIds = selectedRows.map(item => {
        return item.id;
      });
    },
    // 弹窗用户 分页
    userPageChange(pageNumber) {
      this.userPage = pageNumber;
      this.selectUserFn();
    },
    // 点击弹窗的 查询按钮
    collectionMit() {
      this.page = 1;
      this.selectUserFn();
    }
  }
};
</script>

<style lang="scss" scoped>
.addApplicationForVehicle {
  .newsDetial-header {
    position: relative;
    background: #fff;
    padding: 0 40px;
    .newsDetial-title {
      height: 26px;
      color: rgba(56, 56, 56, 1);
      font-size: 18px;
      line-height: 26px;
      font-weight: bold;
    }
    .newsDetial-abstract {
      color: rgba(166, 166, 166, 1);
      font-size: 14px;
      line-height: 22px;
    }
    .detial-top-btn {
      position: absolute;
      right: 87px;
      top: 0;
    }
  }
  .detial-cont {
    margin: 24px 16px;

    .detial-cont-title {
      background: #fff;
      height: 55px;
      color: rgba(0, 0, 0, 0.85);
      font-size: 16px;
      line-height: 55px;
      text-align: left;
      padding-left: 32px;
    }
    .detial-cont-view {
      background: #fff;
      padding: 30px;
      .accessory-btn {
        margin-top: 20px;
        display: flex;
        align-items: center;
        justify-content: center;
      }
    }
  }
  .detial-bottom {
    height: 56px;
    background-color: #fff;
    display: flex;
    align-items: center;
    justify-content: flex-end;
  }
}
// 打印内容不能嵌套写样式
.print-title {
  text-align: center;
  font-size: 18px;
  font-weight: 700;
  height: 50px;
  line-height: 50px;
}
.card-title {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
}
.card-item-title {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
</style>



// WEBPACK FOOTER //
// src/views/MedicalFee/detail.vue